<template>
  <div>
    <Sidebar :resource="drawer" />

    <v-app-bar color="#FFFFFF" app class="navbar" elevation="1">
      <div class="app-itens">
        <div class="sidebar-action">
          <v-btn
            @click="toggleSidebar()"
            color="#09b86c"
            icon
            elevation="0"
            small
          >
            <v-icon color="#086318">{{ menuIcon }}</v-icon>
          </v-btn>

          <span class="pageIndicator">{{
            routeName
          }}</span>
        </div>

        <Menu :resource="authUser" />
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import Sidebar from "../sidebar/Sidebar-comp.vue";
import Menu from "./MenuNavbar-comp.vue"; 
import { AbilityMixin } from "@/mixins/ability.mixin";
export default {
  mixins: [AbilityMixin],
  data() {
    return {
      drawer: null,
      menuIcon: "mdi-menu",
      authUser: {
        initials: "",
        fullName: "",
        email: "",
      },
    };
  },

  components: {
    Sidebar,
    Menu,
  },

  computed: {
    routeName(){
      return this.$route.name;
    }
  },

  created() { 
    this.fillUserShortcuts(); 
  },

  methods: {
    toggleSidebar() {
      this.drawer = !this.drawer
    },
    
    fillUserShortcuts() {
      const userData = this.getCurrentSession

      this.authUser.initials = userData.name.substr(0, 1);
      this.authUser.fullName = userData.name.split(' ')[0];
      this.authUser.email = userData.email; 
    }
  }
};
</script>

<style>
.navbar {
  position: absolute !important;
  margin-top: 20px !important;
  margin: 20px;
  border-radius: 10px !important;
}

.app-itens {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.sidebar-action {
  display: flex;
  align-items: center;
}

.sidebar-action > .pageIndicator {
  font-size: 16px;
  font-family: "Poppins";
  font-weight: 500;
  margin-left: 10px;
}
</style>
